// extracted by mini-css-extract-plugin
export var actions = "_me-5";
export var assistantBubble = "_me-3";
export var assistantRow = "_me-6";
export var bubble = "_me-0";
export var humanAvatar = "_me-4";
export var inlineToolCard = "_me-1";
export var userBubble = "_me-2";